import Data from 'data';
import { skillAuraStats, skillFormula } from 'logic/skills/calc';
import { DamageCalculator, missileDamage } from '../damage';
import { missileDPS } from '../dps';

const functions = {};

// DiabWall

functions[102] = {
  damage(skill, stats, weapon, level, target) {
    return missileDamage(Data.missileByName[skill.srvmissilea], stats, weapon, level, target);
  },
  dps(id, stats, level, target, info) {
    const skill = Data.skills[id];
    const missile = Data.missileByName[skill.srvmissilea];
    if (!missile) return;
    return missileDPS(skill, missile, stats, level, target, info);
  },
};

// Monster Frenzy

functions[109] = {
  showActive: id => !!Data.skills[id].aurastate,
  active: {
    stacks: 0,
  },
  aura(id, stats, level, active) {
    level = Math.min((active || this.active).stacks || 0, level);
    if (!level) return;
    const skill = Data.skills[id];
    return {
      level,
      state: skill.aurastate,
      stats: () => skillAuraStats(skill, stats, level),
    };
  },
  damage(skill, stats, weapon, level, target) {
    if (!weapon) return null;
    const calc = new DamageCalculator(stats, weapon, false, true);
    if (skill.etype) {
      calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
        skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    }
    calc.skillbonus('damagepercent', skillFormula(skill, 'clc2', stats, level));
    calc.srcdam(skill.srcdam);
    calc.skillbonus('tohit_percent', skillFormula(skill, 'toht', stats, level));
    calc.resultflags = skill.resultflags;
    return calc.calculate(target);
  },
};

export default functions;
